import React, {Fragment} from "react";
import Sidebar from "../../components/Sidebar";
import NsAccordion from "../../components/accordion/NsAccordion";

export default function ArchivioMarcheView({
                                               isMobile,
                                               getAlberoStruttura,
                                               goToFiat,
                                           }) {

    return (
        <Fragment>
            <div className={"container-fluid pt-3"}>
                <Fragment>
                    <Sidebar
                        sidebarContent={() => {
                            return isMobile ?
                                <NsAccordion
                                    titolo={'Struttura kpi'}
                                    label={'fas fa-stream'}>
                                    {
                                        getAlberoStruttura()
                                    }
                                </NsAccordion>
                                : getAlberoStruttura()
                        }}
                    >
                        <div className={"w-100 text-center"}>
                            <img
                                src={`assets/img/logo_fiat_big.png`}
                                className="img-fluid ns-cursor-pointer"
                                style={{maxHeight: "45rem"}}
                                onClick={() => {
                                    goToFiat();
                                }}
                            />
                        </div>
                    </Sidebar>
                </Fragment>
            </div>
        </Fragment>
    );
}